"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface BAPBTailoringQuestionsProps {
  onBack?: () => void;
}

const TAILORING_QUESTIONS: TailoringQuestion[] = [
  {
    id: "BAPB-1",
    question:
      "Does the entity have an adequate system in place to distinguish between biological assets, harvested crop (inventory) and processing after harvest.",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "BAPB-2",
    question:
      "Is there any significant degree of estimation uncertainty involved in any of the assumptions based on the following factors (as per SA 540 – Auditing Accounting Estimates, Including Fair Value Accounting Estimates, And Related Disclosures): Accounting estimates that are frequently made and updated because they relate to routine transactions; Accounting estimates derived from data that is readily available; Accounting estimates arising in entities that engage in business activities that are not complex.",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "BAPB-3",
    question:
      "Is there any significant management bias involved in any of the assumptions?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "BAPB-4",
    question:
      "Has the management used any expert in arriving at the fair value less costs to sell?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function BAPBTailoringQuestions({ onBack }: BAPBTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Biological Assets other than Bearer Plants"
      title="BAPB Tailoring Questions"
      description="Customize the audit program with entity-specific questions"
      questions={TAILORING_QUESTIONS}
      onBack={onBack}
    />
  );
}
